import { baseRequest, fileUploadRequest } from './base'

// 查询学期列表
function getTermList(params) {
  return baseRequest('api/pcWeb/teaTermOverview/termList', 'get', params)
}

// 获取问卷列表
function getQuestionnaireList(params) {
    return baseRequest('/api/teaTermEvaluation/list','get',params)
}

// 获取维度
function getDimension() {
    return baseRequest('/api/teaTermEvaluationDimension/list','get')
}

// 获取问卷信息
function getQuestionnaireDetail(id) {
    return baseRequest(`/api/bureau/teaTermEvaluation/getTermEvaluationById/${id}`,'get')
}

// 获取预览二维码
const getQrCode = (id) => {
  return baseRequest(`/api/bureau/teaTermEvaluation/getTermEvaluationQRcode/${id}`,'get')
}

// 获取问题列表
function getQuestionList(id,schoolId) {
    return baseRequest(`/api/teaTermEvaluation/getItemByEvaluationId/${id}`,'get',{schoolId})
}

// 统计维度数量
const getDimensionCount = (id) => {
    return baseRequest(`/api/teaTermEvaluationItem/dimensionCountNumber/${id}`,'get')
  }

// 维度平均分
const getDimensionAverage = (id,schoolId) => {
    return baseRequest(`/api/teaTermEvaluation/listEvaluationSchoolReport/${id}`,'get',{schoolId})
  }
// 分数占比
const getScorePercentage = (id,schoolId) => {
  return baseRequest(`/api/teaTermEvaluation/schoolEvaluationScorePercentage/${id}`,'get',{schoolId})
}

// 家长评分表
const getParentSummary = (params) => {
  return baseRequest(`/api/teaTermEvaluation/listTermEvaluationFeedBackSummary`,'get',params)
}

// 导出问卷数据
const exportExcel = (params) => {
  return fileUploadRequest(`/api/teaTermEvaluation/exportStudentEvaluationSource`,params)
}

// 家长评分详情
const getParentDetail = (params) => {
  return baseRequest(`/api/teaTermEvaluationReport/fillEvaluationDetail`,'get',params)
}
// 获取班级百分比详情
const getClassQuestionList = (params) => {
  return baseRequest(`/api/teaTermEvaluationItem/getItemByIdAndSchoolClassId`,'get',params)
}
// 班级统计
const getClassSummary = (params) => {
  return baseRequest(`/api/teaTermEvaluationReport/classReportSummary`,'get',params)
}
// 导出问卷单个问题回答
function exportQuestion(QId,id) {
  return baseRequest(`/api/teaTermEvaluationItem/export/${QId}/${id}`, 'get')
}

export default {
  getQrCode,
  getTermList,
  exportExcel,
  getDimension,
  exportQuestion,
  getParentDetail,
  getClassSummary,
  getQuestionList,
  getParentSummary,
  getDimensionCount,
  getScorePercentage,
  getDimensionAverage,
  getQuestionnaireList,
  getClassQuestionList,
  getQuestionnaireDetail,
}
